import { render, staticRenderFns } from "./manual-match.vue?vue&type=template&id=3fc0965a&scoped=true"
import script from "./manual-match.vue?vue&type=script&lang=js"
export * from "./manual-match.vue?vue&type=script&lang=js"
import style0 from "./manual-match.vue?vue&type=style&index=0&id=3fc0965a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc0965a",
  null
  
)

export default component.exports